import { Ok, ok } from 'neverthrow'

/**
 * Default validator that always returns true
 */
export const defaultValidator = (): Ok<true, never> => {
  return ok(true)
}
